import { useQuery } from "@tanstack/react-query";

import { useDashboardUser } from "~/modules/dashboard/hooks/useDashboardUser.tsx";
import { kpiFigureQueries } from "~/modules/user/api/kpiFigure/kpiFigureQueries.ts";

export function useKpiFigures() {
	const user = useDashboardUser();

	return useQuery(kpiFigureQueries.detail(user?.id ?? ""));
}
